module.exports = __webpack_public_path__ + "img/virus.c1ba95cc.png";